<template>
  <button type="button">
    <svg
      class="like"
      :class="[{ selected }, theme]"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      @click="handleClick"
    >
      <path
        fill="transparent"
        stroke="white"
        stroke-width="2"
        d="M34 9c-4.2 0-7.9 2.1-10 5.4C21.9 11.1 18.2 9 14 9C7.4 9 2 14.4 2 21c0 11.9 22 24 22 24s22-12 22-24c0-6.6-5.4-12-12-12z"
      />
    </svg>
  </button>
</template>
<script lang="ts" setup>
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineEmits(["update:selected"]);
interface Props {
  theme?: string;
  size?: number;
}
const props = defineProps({
  theme: { default: 'primary' },
  size: { default: 3 },
  selected: { type: Boolean }
});

const { selected } = __MACROS_useVModel("selected");
const csssize = computed(() => {
  return `${props.size}rem`;
});
const handleClick = () => {
  selected.value = !selected.value;
};
</script>
<style lang="scss" scoped>
svg {
  cursor: pointer;
}
button {
  width: v-bind(csssize);
  height: v-bind(csssize);
  svg {
    width: 100%;
    height: auto;
    path {
      transition: fill 300ms $ease-out-quad;
      stroke: var(--color_neutral_100);
    }
  }
  &:hover,
  &:focus {
    svg {
      path {
        stroke: var(--color_secondary);
      }
    }
  }
}
</style>
